module.exports = __webpack_public_path__ + "img/6009547.jpg";